<template>
  <div
    class="ModalBox-container position-absolute mt-5"
    :class="{'ModalBox--dropzone' : showDropZone}"
    v-if="showDropZone"
    @dragleave.prevent="dragLeaveHandler"
    @dragover.prevent
    @drop.prevent="dropHandler"
  >
    <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
      <span
        class="Fuell-Text Fuell-Text--bolder my-4"
        id="dropzone-text"
      >{{$t('dropzone_drag_and_drop_files_info')}}</span>
      <i18n
        tag="span"
        class="Fuell-Text Fuell-Text--bolder my-4"
        id="dropzone-text"
        v-if="fileCount > 0"
        path="dropzone_drag_and_drop_files_upload_count"
      >
        <template v-slot:fileCount>
          {{fileCount}}
        </template>

      </i18n>
      <img
        id="dropzone-receipt-icon"
        width="24px"
        height="24px"
        alt="drop-file-icon"
        style="z-index:1"
        :src="require('@/assets/img/icons/icon-upload.svg')"
      >
      <spinner v-if="showSpinner" />

    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'
export default {
  name: 'ModalDropZone',
  components: {
    Spinner
  },
  props: {
    showDropZone: {
      type: Boolean,
      required: true
    },
    showSpinner: {
      type: Boolean
    },
    fileCount: {
      type: Number,
      default: 0
    },
    dragAndDropLabel: {
      type: String,
      default: 'drop_zone_default_drag_and_drop_label'
    }

  },
  methods: {
    dragLeaveHandler (event) {
      this.$emit('dragleave', event)
    },
    dropHandler (event) {
      this.$emit('drop', event)
    }
  }

}
</script>

<style scoped>
.ModalBox--dropzone {
  position: absolute;
  border: 2px dashed var(--gray);
  border-radius: 20px;
  left: 7px;
  top: 7px;
  height: calc(100% - 15px);
  width: calc(100% - 15px);
  z-index: 999999;
  margin: 0 !important;
}
.ModalBox--dropzone * {
  pointer-events: none;
}
</style>
